import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Expire } from './expire';
import { DAPI_ROOT_URL } from '../globalConfiguration';

export function SmsVerification(props) {
  const { uuid, onVerified, identity = 'smsid.no', phone, country, language } = props;

  if (!uuid) {
    throw 'missing leaduuid';
  }

  if (!identity) {
    throw 'missing identity';
  }

  const [attemptUuid, setAttemptUUid] = useState('');
  const [value, setValue] = useState('');
  const [retries, setRetries] = useState(1);
  const [disabled, setDisabled] = useState(false);
  const [firstBlurred, setFirstBlurred] = useState(false);
  const [verified, setVerified] = useState(false);
  const [firstTyped, setFirstTyped] = useState(false);

  const { isLoading, data } = useQuery({
    queryKey: ['sms-verification', attemptUuid, value, retries],
    queryFn: async () => {
      const response = await fetch(DAPI_ROOT_URL + '/verify/verify', {
        method: 'POST',
        body: JSON.stringify({
          uuid: attemptUuid,
          value,
          type: 'phone',
        }),
      });
      return await response.json();
    },
    enabled: value.length === 4,
    refetchOnWindowFocus: false,
  });

  const { data: dispatchData, ...dispatch } = useQuery({
    queryKey: ['sms-dispatch', uuid, phone, country, identity],
    queryFn: async () => {
      const response = await fetch(DAPI_ROOT_URL + '/verify/dispatch', {
        method: 'POST',
        body: JSON.stringify({
          uuid: uuid,
          value: phone,
          type: 'phone',
          source: window.location.host,
          country,
          identity,
        }),
      });
      return await response.json();
    },
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data?.data?.verified) {
      setVerified(true);
      setDisabled(true);
      onVerified();
    }
  }, [data]);

  useEffect(() => {
    if (dispatchData?.data?.uuid) {
      setAttemptUUid(dispatchData.data.uuid);
    }
  }, [dispatchData]);

  const successClass = () => {
    if (verified) {
      return 'lz-input-success';
    }

    if (firstBlurred && firstTyped && !verified) {
      return 'lz-input-error';
    }

    return '';
  };

  return (
    <>
      <div className="lz-input-wrapper">
        <div style={{ display: 'block' }} className="lz-alert">
          {language['leazard-two-factor-help-text']}
        </div>
      </div>

      <div className="lz-input-wrapper">
        <label htmlFor="">{language['leazard-two-factor-label']}</label>

        <div className={`lz-input ${successClass()}`}>
          {isLoading && (
            <div className="lz-spinner lz-visible">
              <i className="fa fa-spinner fa-spin" />
            </div>
          )}

          <div className="lz-checkmark">
            <i className="fa fa-check" />
          </div>

          <input
            tabIndex={0}
            inputMode="numeric"
            pattern="[0-9]{4}"
            placeholder="1234"
            name="token"
            onBlur={() => {
              if (!firstBlurred) setFirstBlurred(true);
            }}
            disabled={disabled}
            type="text"
            autoFocus={true}
            autoComplete="one-time-code"
            value={value}
            onChange={(event) => {
              if (!firstTyped) setFirstTyped(true);
              setValue(event.target.value);
            }}
          />

          <span className="lz-input-bar" />
        </div>
        {firstBlurred && !verified && (
          <div className="lz-error">
            <span>
              {value.length === 0
                ? language['error-mandatory']
                : language['sms-verification-error-message']}
            </span>
          </div>
        )}
      </div>

      <div className="lz-input-wrapper">
        <span className="lz-extratext">
          {language['sms-verification-code-not-received-first']}{' '}
          <a
            onClick={() => {
              if (!verified) {
                void dispatch.refetch();
                setRetries((r) => r + 1);
              }
            }}
          >
            {language['sms-verification-code-not-received-link']}
          </a>
          {language['sms-verification-code-not-received-last']}
        </span>
      </div>

      {!dispatch.isFetching && (
        <Expire retries={retries}>
          <div className="lz-input-wrapper">
            <span className="lz-extratext">
              <div className="lz-alert" style={{ display: 'block' }}>
                <p
                  style={{
                    margin: 0,
                    color: '#000',
                    fontSize: '14px',
                  }}
                >
                  {!!dispatchData?.success
                    ? language['sms-verification-code-is-sent-again']
                    : language['sms-verification-code-retry-error']}
                </p>
              </div>
            </span>
          </div>
        </Expire>
      )}
    </>
  );
}
